/* eslint-disable prefer-arrow-callback */
import '../scss/main.scss';
import LocationMap from './location-map';

window.addEventListener('DOMContentLoaded', function(){
	let mapContainers = document.querySelectorAll('.mmap-wrapper');

	if (mapContainers.length < 1) {
		return;
	}

	mapContainers = [].slice.call(mapContainers);

	mapContainers.forEach( container => {

		const options = {
			zoomLvl: container.getAttribute('data-zoom-lvl') ? parseInt(container.getAttribute('data-zoom-lvl')) : '',
			mapType: container.getAttribute('data-map-type') ? container.getAttribute('data-map-type') : '',
			locations: container.getAttribute('data-locations') ? JSON.parse(container.getAttribute('data-locations')) : '',
			overlays: container.getAttribute('data-overlays') ? JSON.parse(container.getAttribute('data-overlays')) : '',
			showMarkerMenu: container.getAttribute('data-show-marker-menu') ? container.getAttribute('data-show-marker-menu') : '',
			themeUrl: container.getAttribute('data-theme-url') ? container.getAttribute('data-theme-url') : ''
		};

		new LocationMap(
			options,
			container
		);
	});
});